import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const ProducePreviewOverlapLoadingOverlayStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "produce-preview-overlap-loading-overlay",
  },
)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${ScreenDepth.CONTENT_BLUR_OVERLAY};
  overflow: hidden;
  pointer-events: none;
  background: rgba(248, 250, 252, 0.38);
  backdrop-filter: blur(2px);
`;
